import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { ajaxActions } from 'common/ajax/store.js';
import { actionCreators } from './store.js';

const styles = (theme) => ({
  root: {},
  name: {
    marginBottom: 20,
  },
  data: {
    minHeight: 40,
  },
  dataType: {
    '& p': {
      color: theme.palette.common.lightText,
    },
  },
  divider: {
    marginTop: 20,
    marginBottom: 20,
  },
  indent: {
    padding: '10px 18px',
    '& a': {
      textDecoration: 'underline',
    },
    backgroundColor: '#f9fcfd',
  },
  copyButton: {
    padding: 0,
    marginLeft: 3,
    '& svg path': {
      fill: theme.palette.common.darkerText,
    },
  },
  edit: {
    position: 'relative',
    display: 'flex',
    float: 'right',
    top: '0px',
    color: '#004A8C !important',
    '&:hover': {
      color: '#004A8C !important',
    },
  },
  prefText: {
    position: 'relative',
    display: 'flex',
    float: 'right',
    top: '0px',
    color: '#004A8C !important',
    fontWeight: 'bold',
    fontStyle: 'normal',
    '&:hover': {
      color: '#004A8C !important',
    },
  },
  tags: {
    display: 'flex',
    '& span': {
      marginRight: 5,
    },
  },
});

class SetAsPreferred extends React.Component {
  handleSubmit = (contact) => {
    const { profileDetails, localisation } = this.props;
    const fullName = profileDetails.firstName + ' ' + profileDetails.lastName;

    let model = {};
    this.props.resetAjaxStatus();

    if (contact.type === 'EM') {
      model = {
        EmailAddress: contact.email,
        EmailName:
          contact.emailName === '' || contact.emailName === null
            ? fullName
            : contact.emailName,
        IsPrimary: true,
      };

      this.props.updateCurrentEmailAddress(
        profileDetails.adfitNo,
        contact.id,
        JSON.stringify(model)
      );
    } else {
      model = {
        PhoneType: localisation.prompts.phoneType[contact.type.toUpperCase()],
        PhoneName:
          contact.contactName === '' || contact.contactName === undefined
            ? fullName
            : contact.contactName,
        PhoneNumber: contact.number,
        CountryCode: contact.countryCode,
        IsPrimary: true,
      };
      this.props.updateCurrentPhoneContact(
        profileDetails.adfitNo,
        contact.id,
        JSON.stringify(model)
      );
    }
  };

  render() {
    const { classes, currentContact } = this.props;
    return (
      <React.Fragment>
        <a
          className={classes.prefText}
          onClick={() => this.handleSubmit(currentContact)}
          aria-hidden="true">
          Set as Preferred
        </a>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  ajax: state.ajax,
  localisation: state.localisation,
});

const mapDispatchToProps = (dispatch) => {
  return {
    setAjaxStatus: (isLoading) => {
      dispatch(ajaxActions.setAjaxStatus(isLoading));
    },
    updateAjaxStatus: () => {
      dispatch(ajaxActions.updateAjaxStatus());
    },
    resetAjaxStatus: () => {
      dispatch(ajaxActions.resetAjaxStatus());
    },
    getAccountDetails: (adfitNo) => {
      dispatch(actionCreators.getAccountDetails(adfitNo));
    },
    updateCurrentPhoneContact: (adfitNo, phoneNumberId, model) => {
      dispatch(
        actionCreators.updateCurrentPhoneContact(adfitNo, phoneNumberId, model)
      );
    },
    updateCurrentEmailAddress: (adfitNo, emailAddressId, model) => {
      dispatch(
        actionCreators.updateCurrentEmailAddress(adfitNo, emailAddressId, model)
      );
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(SetAsPreferred));
